module.exports = __webpack_public_path__ + "static/media/มะแม.1d491b33.png";